<div class="card goal" [class.open]="isOpen" [class.auto-focus]="autoFocus" *ngIf="goal">
  <div class="goal-head" (click)="onToggleClick()">
    <div>
      <div class="goal-name">{{ goal.goalName }}</div>
      <div class="goal-sub">Goal #{{ goal.goalNumber }} &middot; Owner: {{ goal.owner }} &middot; {{ goal.dateRange }}</div>
    </div>
    <div>
      <div class="klabel">Progress to target</div>
      <div class="bignum">{{ goal.currentValue | formatValue: goal.recommendedType }} <span>of {{ goal.targetValue | formatValue: goal.recommendedType }}</span></div>
      <div class="bar">
        <i [style.width]="progressBarWidth" [style.background]="barColor"></i>
        <span class="tick" [style.left]="elapsedTick"></span>
      </div>
      <div class="bar-caption">{{ goal.progressPercent | number:"1.0-0" }}% complete &middot; {{ goal.quarterElapsedPercent | number:"1.0-0" }}% of quarter elapsed</div>
    </div>
    <div>
      <div class="klabel">Pace</div>
      <div class="bignum">{{ goal.pacePercent | formatValue: '%' }}</div>
      <div class="momentum" [class]="momentumClass">
        <span class="material-icons">{{ momentumIcon }}</span> {{ momentumLabel }}
      </div>
    </div>
    <div><span class="badge" [class.on]="statusClass === 'on'" [class.off]="statusClass === 'off'" [class.risk]="statusClass === 'risk'">&#9679; {{ statusLabel }}</span></div>
    <div class="chev"><span class="material-icons">expand_more</span></div>
  </div>

  <div class="goal-body">
    <div class="body-grid">
      <div class="body-l">
        <div class="runrate">
          <div class="k">To reach goal</div>
          <div class="v">{{ toReachGoalText }}</div>
          <div class="n">{{ goal.runRateNote }}</div>
        </div>

        <div class="kv">
          <div>
            <div class="k">Target</div>
            <div class="v">{{ goal.targetValue | formatValue: goal.recommendedType }}</div>
          </div>
          <div>
            <div class="k">Current</div>
            <div class="v">{{ goal.currentValue | formatValue: goal.recommendedType }}</div>
          </div>
          <div>
            <div class="k">Gap to target</div>
            <div class="v gap">{{ gapToTargetText | formatValue: goal.recommendedType }}</div>
          </div>
        </div>

        <div class="cmp">
          <div class="cmp-title">How this compares</div>
          <div class="cmp-row" *ngFor="let row of goal.comparisons">
            <span>{{ row.label }}</span>
            <span [class.positive]="row.tone === 'positive'" [class.negative]="row.tone === 'negative'">
              {{ row.value | formatValue: goal.recommendedType }}<ng-container *ngIf="row.secondaryValue != null"> / {{ row.secondaryValue | formatValue: goal.recommendedType }}</ng-container><ng-container *ngIf="row.suffix"> {{ row.suffix }}</ng-container>
            </span>
          </div>
        </div>

        <div class="res" *ngIf="goal.resources && goal.resources.length">
          <div class="klabel">Tools &amp; resources</div>
          <div class="res-list">
            <a [href]="r" target="_blank" *ngFor="let r of goal.resources">
              <span class="material-icons">description</span> {{ goal.goalNumber | goalFileName}}
            </a>
          </div>
        </div>
      </div>

      <div class="body-r">
        <div class="chart-wrap">
          <div class="klabel">Actual vs. required trajectory</div>
          <highcharts-chart
            [options]="chartOptions"
            [oneToOne]="true"
            style="width: 100%; height: 190px; display: block;"
          ></highcharts-chart>
        </div>

        <div class="subhead">Linked tasks ({{ completedTaskCount }} of {{ totalTaskCount }} complete)</div>
          <div class="linked-task-list" *ngIf="goal.tasks && goal.tasks.length">
            <label class="gt" *ngFor="let task of goal.tasks" [class.done]="isTaskDone(task)">
              <span class="t" (click)="$event.preventDefault(); $event.stopPropagation(); openTask.emit(task.taskId)">{{ task.title }}</span>
              <span class="m">
                <ng-container *ngIf="isTaskDone(task)">Completed {{ task.completedDate }} &middot; {{ task.assignedTo }}</ng-container>
                <ng-container *ngIf="!isTaskDone(task)">Due {{ task.dueDate | date: 'MMM d' }} &middot; {{ task.assignedTo }}</ng-container>
                <span class="tag past-due" *ngIf="isTaskPastDue(task)">{{ task.daysPastDue }} days past due</span>
              </span>
            </label>
          </div>
        <div class="addtask" (click)="readOnly ? null : addTask.emit(goal)">{{ readOnly ? 'Task actions disabled in HM Preview' : '+ Add a task to this goal' }}</div>

        <div class="subhead">Notes &amp; updates</div>
        <div class="notes" *ngIf="goal.notes && goal.notes.length">
            <div class="note" *ngFor="let note of goal.notes">
            <div class="avatar">{{ note.initials }}</div>
            <div style="flex: 1;">
              <div class="who">{{ note.author }} <span class="when">&middot; {{ note.date }}</span></div>
              <div class="txt" *ngIf="editingNote !== note" [innerHTML]="sanitizeHtml(note.text)"></div>
              <div *ngIf="editingNote === note" class="edit-comment-box">
                <div style="border: 1px solid #ddd; border-radius: 4px">
                  <div class="editor">
                    <ngx-editor-menu [editor]="editEditor" [toolbar]="toolbar"></ngx-editor-menu>
                    <ngx-editor [editor]="editEditor" [(ngModel)]="editNoteText" [placeholder]="'Edit comment...'" style="height: 140px; border-top: 1px solid #ddd"></ngx-editor>
                  </div>
                </div>
                <div class="toggle-row comment-visibility-toggle" *ngIf="!isHM">
                  <label class="switch">
                    <input type="checkbox" [(ngModel)]="editNoteIsHmVisible" />
                    <span class="slider"></span>
                  </label>
                  <div>
                    <div class="t">{{ editNoteIsHmVisible ? "Visible to HM" : "Internal only" }}</div>
                    <div class="s">{{ editNoteIsHmVisible ? "Visible to the Hospital Manager" : "Hidden from the Hospital Manager" }}</div>
                  </div>
                </div>
                <div class="edit-actions">
                  <button class="btn-save-edit" (click)="saveEditNote()">Save</button>
                  <button class="btn-cancel-edit" (click)="cancelEditNote()">Cancel</button>
                </div>
              </div>
            </div>
            <div class="comment-actions" *ngIf="!readOnly && editingNote !== note && isOwnNote(note)">
              <button class="comment-action-btn" (click)="startEditNote(note)" title="Edit comment">
                <span class="material-icons">edit</span>
              </button>
              <button class="comment-action-btn delete" (click)="confirmDeleteNoteDialog(note)" title="Delete comment">
                <span class="material-icons">delete</span>
              </button>
            </div>
          </div>
        </div>
        <div class="composer" *ngIf="!readOnly">
          <div style="flex: 1; border: 1px solid #ddd; border-radius: 4px">
            <div class="editor">
              <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
              <ngx-editor [editor]="editor" [(ngModel)]="noteText" [placeholder]="'Add a note for your RM...'" style="height: 140px; border-top: 1px solid #ddd"></ngx-editor>
            </div>
          </div>
          <button class="btn" (click)="onPostNote()" [disabled]="!noteText?.trim()">Post</button>
        </div>
        <div class="toggle-row comment-visibility-toggle" *ngIf="!isHM && !readOnly">
          <label class="switch">
            <input type="checkbox" [(ngModel)]="noteIsHmVisible" />
            <span class="slider"></span>
          </label>
          <div>
            <div class="t">{{ noteIsHmVisible ? "Visible to HM" : "Internal only" }}</div>
            <div class="s">
              {{
                noteIsHmVisible
                  ? "Visible to the Hospital Manager"
                  : "Hidden from the Hospital Manager"
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="confirmDeleteNote" class="confirmation-backdrop">
  <div class="confirm-dialog">
    <h3>Delete Comment</h3>
    <p>Are you sure you want to delete this comment? This action cannot be undone.</p>
    <div class="dialog-actions">
      <button class="btn-reassign btn-cancel" (click)="cancelDeleteNote()">Cancel</button>
      <button class="btn-reassign btn-confirm" style="background-color: #dc2626" (click)="deleteNoteConfirm()">Delete</button>
    </div>
  </div>
</div>